module.exports = __webpack_public_path__ + "img/76.d2406162.jpg";